import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import translationFi from "./fi/translation";
import translationSv from "./sv/translation";
import translationEn from "./en/translation";

export const LOCALES = ["fi", "en", "sv"] as const;
export type Locale = (typeof LOCALES)[number];

let storedLocale = "fi";

if (typeof localStorage !== "undefined") {
  storedLocale = localStorage.getItem("locale") ?? storedLocale;
}

export const DEFAULT_LOCALE = LOCALES.includes(storedLocale as Locale)
  ? (storedLocale as Locale)
  : "fi";

export const resources = {
  fi: {
    translation: translationFi,
  },
  sv: {
    translation: translationSv,
  },
  en: {
    translation: translationEn,
  },
} as const;

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18next.use(initReactI18next).init({
  lng: DEFAULT_LOCALE, // if you're using a language detector, do not define the lng option
  fallbackLng: "fi",
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources,
});

export default i18next;
